import { request } from '@/utils/request'

export function userChangePwd(data) {
  return request({
    url: '/teacher/change_password',
    method: 'post',
    data
  })
}

export function teachingData(params) {
  return request({
    url: '/api/home/teaching_data',
    method: 'get',
    params
  })
}

export function teacherInfo(params) {
  return request({
    url: '/api/home/info',
    method: 'get',
    params
  })
}

export function studentInfo(params) {
  return request({
    url: '/api/student/info',
    method: 'get',
    params
  })
}

export function teacherDetail(params) {
  return request({
    url: '/api/teacher/detail',
    method: 'get',
    params
  })
}

export function studentDetail(params) {
  return request({
    url: '/api/student/detail',
    method: 'get',
    params
  })
}

export function externalTeacherDetail(params) {
  return request({
    url: '/api/admin/external_user/detail',
    method: 'get',
    params
  })
}

export function studentUpdate(data) {
  return request({
    url: '/api/student/update',
    method: 'post',
    data
  })
}
export function studentPassword(data) {
  return request({
    url: '/api/student/change_password',
    method: 'post',
    data
  })
}

// 校外师生修改密码
export function externalUserChangePwd(data) {
  return request({
    url: '/api/admin/external_user/change_password',
    method: 'post',
    data
  })
}

export function createLessonList(params) {
  return request({
    url: '/api/home/creator_list',
    method: 'get',
    params
  })
}

export function prepareLessonList(params) {
  return request({
    url: '/api/home/prepare_lesson_list',
    method: 'get',
    params
  })
}

export function resRecommendList(params) {
  return request({
    url: '/api/home/res_recommend_list',
    method: 'get',
    params
  })
}
